'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _Well = require('react-bootstrap/lib/Well');

var _Well2 = _interopRequireDefault(_Well);

var _utils = require('../../../utils');

var _common = require('../../common');

var _AdditionalLiensModal = require('./AdditionalLiensModal');

var _AdditionalLiensModal2 = _interopRequireDefault(_AdditionalLiensModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var formatMoney = _utils.FormattingUtils.formatMoney,
    formatParagraphs = _utils.FormattingUtils.formatParagraphs;
var AdditionalLiens = (_dec = (0, _mobxReact.inject)('CaseStore', 'UiStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  _inherits(AdditionalLiens, _Component);

  function AdditionalLiens(props) {
    _classCallCheck(this, AdditionalLiens);

    var _this = _possibleConstructorReturn(this, (AdditionalLiens.__proto__ || Object.getPrototypeOf(AdditionalLiens)).call(this, props));

    _initDefineProp(_this, 'liens', _descriptor, _this);

    _this.liens = props._case.additional_liens.liens || [{}];
    return _this;
  }

  _createClass(AdditionalLiens, [{
    key: 'firstRowText',
    value: function firstRowText(lien) {
      return lien.type ? lien.type + ' - ' + formatMoney(lien.amount) : formatMoney(lien.amount);
    }
  }, {
    key: 'handleAdditionalLiensSubmit',
    value: function handleAdditionalLiensSubmit(data, liens) {
      var _props = this.props,
          CaseStore = _props.CaseStore,
          _case = _props._case,
          UiStore = _props.UiStore,
          submitData = { additional_liens: data };


      this.liens = liens;

      CaseStore.update({ caseId: _case.id, data: submitData });
      UiStore.modals.AdditionalLiens.close();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          UiStore = _props2.UiStore,
          _case = _props2._case;


      return _react2.default.createElement(
        _Well2.default,
        null,
        _react2.default.createElement(
          'h3',
          null,
          'Additional Liens',
          _react2.default.createElement(
            _Button2.default,
            { className: 'btn-edit pull-right', bsStyle: 'link', onClick: UiStore.modals.AdditionalLiens.open },
            _react2.default.createElement(_common.Icon, { type: 'pencil', className: 'icon-edit' })
          )
        ),
        _react2.default.createElement(
          _common.InfoWell,
          null,
          this.liens.map(function (lien, idx) {
            return _react2.default.createElement(
              'div',
              { key: idx },
              idx !== 0 && _react2.default.createElement('hr', null),
              _react2.default.createElement(
                _Row2.default,
                null,
                _react2.default.createElement(
                  _common.InfoWell.Label,
                  null,
                  'Other Lien'
                ),
                _react2.default.createElement(
                  _common.InfoWell.Value,
                  null,
                  _this2.firstRowText(lien)
                )
              ),
              _react2.default.createElement(
                _Row2.default,
                null,
                _react2.default.createElement(
                  _common.InfoWell.Label,
                  null,
                  'Notes'
                ),
                _react2.default.createElement(
                  _common.InfoWell.Value,
                  null,
                  formatParagraphs(lien.note)
                )
              )
            );
          })
        ),
        UiStore.modals.AdditionalLiens.showing() && _react2.default.createElement(_AdditionalLiensModal2.default, {
          _case: _case,
          onClose: UiStore.modals.AdditionalLiens.close,
          onValidSubmit: this.handleAdditionalLiensSubmit
        })
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return AdditionalLiens;
}(_react.Component), _class3.propTypes = {
  _case: _propTypes2.default.object,
  CaseStore: _propTypes2.default.object,
  UiStore: _propTypes2.default.object
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'liens', [_mobx.observable], {
  enumerable: true,
  initializer: null
})), _class2)) || _class) || _class) || _class);
var _default = AdditionalLiens;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(formatMoney, 'formatMoney', '/app/src/components/page-case/main-details/AdditionalLiens.js');
  reactHotLoader.register(formatParagraphs, 'formatParagraphs', '/app/src/components/page-case/main-details/AdditionalLiens.js');
  reactHotLoader.register(AdditionalLiens, 'AdditionalLiens', '/app/src/components/page-case/main-details/AdditionalLiens.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/main-details/AdditionalLiens.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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